// src/components/AboutUsBanner.js
import React from 'react';
import './VideoBanner.css'; // We’ll define styles separately

const VideoBanner = () => {
  return (
    <div className="Video-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">Up Comming Events</h2>
       
      </div>
    </div>
  );
};

export default VideoBanner;
